import { gql } from '@apollo/client';

export const GET_DEPENDENT_ORDERS = gql`
  query GetActiveDependentOrdersById($id: UUID) {
    getActiveDependentOrdersById(id: $id) {
      result
    }
  }
`;
